import React from "react";
import PropTypes from 'prop-types';
import './file_upload.scss';
import { Button, Card, Typography } from "../../index";


export const FileUpload = (props) => {
    const { onHandleChange, accept, placeholder, acceptFileText, maxFileSize, disabled, id, maxFileSizeText } = props;
    const [data, setData] = React.useState({
        invalidInput: false,
        inputErrorMsg: "",
        fileSizeInMb: null,
        value: null
    })

    const onChange = (event) => {
        event.persist();
        const input = event.target;

        const value = input.files && input.files[0] && input.files[0].name ? input.files[0].name : '';
        const fileSize = input.files && input.files[0] && input.files[0].size;
        const fileSizeInMb = fileSize ? (fileSize / 1024 / 1024).toFixed(2) : 0;
        if (value) {
            const file = input.files[0];  // setting event.target.value as empty in the last line is executed first, so need one temp variable holding the file.

            setData({ ...data, value: value, invalidInput: false, fileSizeInMb: parseFloat(fileSizeInMb) });
            if (onHandleChange) {
                onHandleChange(event, value, value.trim() !== '' && isValidate(value, parseFloat(fileSizeInMb)), file, data.inputErrorMsg);
            }

        }
        event.target.value = "";  //fix to fire the onChange for same fileName
    }

    const isValidate = (value, fileSizeInMb) => {
        //const { value, fileSizeInMb } = data;
        const { maxFileSize } = props;
        if (value) {
            const accept = props.accept ? props.accept.toLowerCase() : "";
            const fileExtention = value.split('.').pop().toLowerCase();
            if (accept.split(',').indexOf("." + fileExtention) < 0) {
                setData({ ...data, inputErrorMsg: `Please select a valid document type: ${accept}`, invalidInput: true });
                return false;
            }
            else if (fileSizeInMb > maxFileSize) {
                setData({ ...data, inputErrorMsg: `Please upload a file smaller than ${maxFileSize} MB.`, invalidInput: true });
                return false;
            }
            else {
                setData({ ...data, inputErrorMsg: "", invalidInput: false });
                return true;
            }
        }
        return false;
    }

    const fileInput = React.useRef(null);

    const handleClick = event => {
        event.preventDefault();
        fileInput.current.click();
    };

    return (
        <>
            <Card className="bsw-file-upload">
                <div className="bsw-file-upload-content">
                    <div className="bsw-file-upload-primary-message">
                        <Typography
                            bold
                            color={"$color-secondary-a2"}
                            tag="div"
                            textAlign="start"
                            type="body-02"
                            responsive
                        >
                            {placeholder}
                        </Typography>
                    </div>
                    <div className="bsw-file-upload-secondary-message">
                        <Typography
                            color={"$color-secondary-a2"}
                            tag="div"
                            textAlign="start"
                            type="meta-01"
                            responsive
                        >
                            {acceptFileText}
                        </Typography>
                        <Typography
                            color={"$color-secondary-a2"}
                            tag="div"
                            textAlign="start"
                            type="meta-01"
                            responsive
                        >
                            {maxFileSizeText}
                        </Typography>
                    </div>
                </div>
                <div className="bsw-file-upload-button">
                    <Button onClick={e => handleClick(e)} fluid htmlFor={id} variant="secondary" disabled={disabled}>
                        <label htmlFor="file" className="file-selection">Attach File</label>
                    </Button>
                    <input ref={fileInput} className="fileUpload" type="file" id={id} disabled={disabled} onChange={onChange}
                        accept={accept} />
                </div>
            </Card >
            {data.inputErrorMsg &&
                <div className="bsw-file-upload-error-message">
                    <Typography
                        color={"$color-system-b1"}
                        tag="div"
                        textAlign="start"
                        type="meta-01"
                        responsive
                    >
                        {data.inputErrorMsg}
                    </Typography>
                </div>
            }
        </>
    );
};
FileUpload.defaultProps = {
    maxFileSize: 5,
    placeholder: "",
    acceptFileText: "",
    onHandleChange: () => ({})
}
FileUpload.propTypes = {

}
